module.exports = __webpack_public_path__ + "static/img/block1.357dc53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/parkDescription/block1.png
// module id = vCDY
// module chunks = 1